export default __webpack_public_path__ + "static/media/summaryIcon.542bce35.svg";